import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueAnalytics from 'vue-analytics';
import VeeValidate from 'vee-validate';
import VueProgressBar from 'vue-progressbar';
import Nl2br from 'vue-nl2br';
import bugsnag from '@bugsnag/js';
import bugsnagVue from '@bugsnag/plugin-vue';
import NLVeeLocale from './strings/validator/messages/nl.js';
import './filters';

import SportModal from './components/SportModal.vue';
import CheckboxField from './components/form/CheckboxField.vue';
import RadioField from './components/form/RadioField.vue';
import InputField from './components/form/InputField.vue';
import SelectField from './components/form/SelectField.vue';
import VselectField from './components/form/VSelectField.vue';
import PasswordField from './components/form/PasswordField.vue';
import SubmitField from './components/form/SubmitField.vue';
import DateField from './components/form/DateField.vue';
import FormError from './components/form/FormError.vue';
import VoucherField from './components/form/VoucherField.vue';
import LocationField from './components/form/LocationField.vue';
import vSelect from 'vue-select'

Vue.component('v-select', vSelect);
Vue.component('CheckboxField', CheckboxField);
Vue.component('RadioField', RadioField);
Vue.component('FormError', FormError);
Vue.component('InputField', InputField);
Vue.component('SelectField', SelectField);
Vue.component('VselectField', VselectField);
Vue.component('PasswordField', PasswordField);
Vue.component('SubmitField', SubmitField);
Vue.component('DateField', DateField);
Vue.component('VoucherField', VoucherField);
Vue.component('LocationField', LocationField);
Vue.component('SportModal', SportModal);

Vue.component('nl2br', Nl2br);

Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
    id: 'UA-126722758-1',
    checkDuplicatedScript: true,
    router
});

Vue.use(VueProgressBar, {
    color: '#0039A6',
    failedColor: '#0039A6',
    thickness: '3px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 300
    },
    autoRevert: true,
    location: 'top',
    inverse: false
});

Vue.use(VeeValidate, {
    aria: true,
    classNames: {},
    classes: false,
    delay: 1,
    dictionary: {
        nl: NLVeeLocale
    },
    errorBagName: 'errors', // change if property conflicts
    events: 'blur',
    fieldsBagName: 'fields',
    i18n: null, // the vue-i18n plugin instance
    i18nRootKey: 'validations', // the nested key under which the validation messages will be located
    inject: false,
    locale: 'nl',
    strict: true,
    validity: false,
});

const bugsnagClient = bugsnag('303dc75c9af4a0298fe6b458335ce992');
bugsnagClient.use(bugsnagVue, Vue);

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
